import { createContext } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import Cookies from 'js-cookie'

import StepHandler from './StepHandler'
import { RecoveryApi } from '../../api'

export const Recovery = createContext(null)

// Страна по дефолту
const DEFAULT_COUNTRY = 172

const RecoveryForm = ({ setLogin, setOpenRecovery }) => {
  const [step, setStep] = useState(0)
  const [type, setType] = useState('phone')
  const [countryData, setCountryData] = useState(null)
  const [selectedCountry, setSelectedCountry] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [phone, setPhone] = useState(null)
  const [email, setEmail] = useState(null)
  const [error, setError] = useState(null)

  const { executeRecaptcha } = useGoogleReCaptcha()

  useEffect(() => {
    setIsLoading(true)
    const lang = Cookies.get('lang') || 1
    getCountryData(lang)
      .then((res) => {
        setCountryData(res.data.result)
        return res.data.result[DEFAULT_COUNTRY]
      })
      .then((country) => setSelectedCountry(country))
      // eslint-disable-next-line no-console
      .catch((e) => console.error(e))
      .finally(() => setIsLoading(false))
  }, [])

  useEffect(() => {
    document.addEventListener('click', clickHandler)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getCountryData = (lang) => {
    return RecoveryApi.getData('country', `lang_id=${lang}`)
  }

  const clickHandler = (e) => {
    if (e.target.id === 'switchToPhone') {
      switchType('phone')
    }
  }

  const switchType = (newType) => {
    if (type === newType) {
      return
    }
    setError(null)
    setStep(0)
    setType(newType)
  }

  const switchStep = (step) => {
    setError(null)
    if (step === 3) {
      if (type === 'phone') {
        setLogin(phone)
      }
      setOpenRecovery(false)
    }
    setStep(step)
  }

  const handleReCaptchaVerify = () => {
    return executeRecaptcha()
  }

  return (
    <Recovery.Provider
      value={{
        step,
        type,
        isLoading,
        setIsLoading,
        countryData,
        setCountryData,
        selectedCountry,
        setSelectedCountry,
        phone,
        setPhone,
        email,
        setEmail,
        switchType,
        switchStep,
        error,
        setError,
        handleReCaptchaVerify,
      }}
    >
      <StepHandler />
    </Recovery.Provider>
  )
}

export default RecoveryForm
